import { BaseIp, ProIp } from "./ApiURL";


//post mapping
export const dashboardAPI = ProIp + "dashboardAPI/";

//login Count Data

//getMapping
export const indexRoutesAPI = ProIp + "indexRoutes";